import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'

import StyleguidePreview from 'components/styleguide-preview'
import Box from 'components/box'
import BoxList from 'components/box-list'
import PrimaryButton from 'components/primary-button'
import PrimaryButtonResponsive from 'components/primary-button-responsive'
import SecondaryButton from 'components/secondary-button'
import IconButton from 'components/icon-button'
import LinkButton from 'components/link-button'
import Status from 'components/status'
import ValueLabel from 'components/value-label'
import Loader from 'components/loader'
import Tabs from 'components/tabs'
import Dropdown from 'components/dropdown'
import Toggle from 'components/toggle'
import EditableFields from './editable-fields'
import AttendeeListPreview from './attendee-list-preview'
import AccessControl from 'components/access-control'
import ButtonGroup from 'components/button-group'
import MetadataWrapper from 'components/metadata-wrapper'
import Input from 'components/input'
import Select from 'components/select'
import HeaderNavBarPreview from './header-nav-bar-preview'

import PlusIcon from '../../../assets/icons/plus.svg'

import styles from './styleguide.css'
import '../../styles/fonts.css'

const options = [
  { label: 'London', value: '1' },
  { label: 'Dublin', value: '2' },
  { label: 'Manchester', value: '3' },
]

class Styleguide extends Component {

  handleTabClick(index) {
    // eslint-disable-next-line no-console
    console.log(`Tab "${index}" clicked`)
  }

  render() {
    /* eslint-disable max-len */
    return (
      <div styleName="page">
        <RelayoutWrapper>
          <Relayout align="center">
            <RelayoutItem lg="10" sm="12">

              <h1 styleName="title">Styleguide</h1>

              <StyleguidePreview
                description="This is the main action button to be used across the site"
                spacing="vertical"
                title="Primary Button"
              >
                <PrimaryButton label="Primary" />
                <PrimaryButton fluid label="Fluid" />
                <PrimaryButton disabled label="Disabled" />
              </StyleguidePreview>

              <StyleguidePreview
                description="Secondary actions"
                spacing="vertical"
                title="Secondary Button"
              >
                <SecondaryButton label="Secondary" />
                <SecondaryButton fluid label="Fluid" />
                <SecondaryButton disabled label="Disabled" />
              </StyleguidePreview>

              <StyleguidePreview
                description="When a link and a button have a child"
                spacing="horizontal"
                title="Link Button"
              >
                <LinkButton label="I am a Link" />
                <LinkButton label="But I am also a Button" />
                <LinkButton disabled label="Disabled" />
              </StyleguidePreview>

              <StyleguidePreview
                description="When a link and a button have a child and they have special responsive powers"
                spacing="horizontal"
                title="Primary Button Responsive"
              >
                <PrimaryButtonResponsive label="I change my type on mobile" />
                <PrimaryButtonResponsive disabled label="Disabled button" />
              </StyleguidePreview>

              <StyleguidePreview
                description="Button with an icon"
                title="Icon Button"
              >
                <IconButton label="Add Dates">
                  <PlusIcon />
                </IconButton>
              </StyleguidePreview>

              <StyleguidePreview
                description="Group a series of buttons together on a single line with the button group."
                spacing="vertical"
                title="Button Group"
              >
                <ButtonGroup
                  buttons={[
                    { text: 'First' },
                    { text: 'Primary', isPrimary: true },
                    { text: 'Last' },
                  ]}
                />

                <ButtonGroup
                  disabled
                  buttons={[
                    { text: 'First' },
                    { text: 'Primary' },
                    { text: 'Last' },
                  ]}
                />
              </StyleguidePreview>

              <StyleguidePreview
                description="Display the current event or performance status."
                spacing="horizontal"
                title="Status"
              >
                <Status label="Sold Out" />
                <Status important label="1 New Date In Review" />
                <Status animated important label="Important and Animated" />
              </StyleguidePreview>

              <StyleguidePreview
                description="This is the main action button to be used across the site"
                spacing="horizontal"
                title="Toggle"
              >
                <Toggle checked />
                <Toggle checked={false} />
                <Toggle small checked />
                <Toggle small checked={false} />
              </StyleguidePreview>

              <StyleguidePreview
                description="Display a value and label on top of each other"
                spacing="vertical"
                title="ValueLabel"
              >
                <Relayout>
                  <RelayoutItem md="4" sm="12">
                    <ValueLabel align="left" label="Small Left" size="small" value="£200.00" />
                  </RelayoutItem>
                  <RelayoutItem md="4" sm="12">
                    <ValueLabel align="center" label="Small Center" size="small" value="£200.00" />
                  </RelayoutItem>
                  <RelayoutItem md="4" sm="12">
                    <ValueLabel align="right" label="Small Right" size="small" value="£200.00" />
                  </RelayoutItem>
                </Relayout>

                <Relayout>
                  <RelayoutItem md="4" sm="12">
                    <ValueLabel align="left" label="Left" value="£200.00" />
                  </RelayoutItem>
                  <RelayoutItem md="4" sm="12">
                    <ValueLabel align="center" label="Center" value="£200.00" />
                  </RelayoutItem>
                  <RelayoutItem md="4" sm="12">
                    <ValueLabel align="right" label="Right" value="£200.00" />
                  </RelayoutItem>
                </Relayout>

                <Relayout>
                  <RelayoutItem md="4" sm="12">
                    <ValueLabel align="left" label="Large Left" size="large" value="£200.00" />
                  </RelayoutItem>
                  <RelayoutItem md="4" sm="12">
                    <ValueLabel align="center" label="Large Center" size="large" value="£200.00" />
                  </RelayoutItem>
                  <RelayoutItem md="4" sm="12">
                    <ValueLabel align="right" label="Large Right" size="large" value="£200.00" />
                  </RelayoutItem>
                </Relayout>

                <Relayout>
                  <RelayoutItem md="4" sm="12">
                    <ValueLabel align="left" size="small" value="7:30pm">
                      <Status label="Sold Out" />
                    </ValueLabel>
                  </RelayoutItem>
                  <RelayoutItem md="4" sm="12">
                    <ValueLabel align="center" size="small" value="7:30pm">
                      <Status important label="In Review" />
                    </ValueLabel>
                  </RelayoutItem>
                  <RelayoutItem md="4" sm="12">
                    <ValueLabel align="right" size="small" value="7:30pm">
                      <Status animated label="Active" />
                    </ValueLabel>
                  </RelayoutItem>
                </Relayout>

              </StyleguidePreview>

              <StyleguidePreview
                description="White box as a container for your content"
                spacing="vertical"
                title="Box"
              >
                <Box padding="none">No padding and not interactive</Box>
                <Box padding="small">Small padding and not interactive</Box>
                <Box padding="medium">Medium padding and not interactive</Box>
                <Box padding="large">Large padding and not interactive</Box>
                <Box interactive padding="medium">Medium Padding and interactive</Box>
              </StyleguidePreview>

              <StyleguidePreview
                description="List of boxes"
                spacing="vertical"
                title="Box List"
              >
                <BoxList padding="small" items={['first']} />
                <BoxList padding="medium" items={['first', 'second', 'third', 'last']} />
                <BoxList padding="large" items={['first', 'second', 'third', 'last']} />
              </StyleguidePreview>

              <StyleguidePreview
                description="The best loader ever"
                title="Loader"
              >
                <Loader />
              </StyleguidePreview>

              <StyleguidePreview
                description="Set of tabs"
                title="Tabs"
              >
                <Tabs active={0} items={['Current', 'Past', 'Future']} onChange={this.handleTabClick} />
              </StyleguidePreview>

              <StyleguidePreview
                description="Dropdown to be used on navigations and tooltips"
                spacing="horizontal"
                title="Dropdown"
              >
                <Dropdown padding="medium" direction="top">Top</Dropdown>
                <Dropdown padding="medium" direction="right">Right</Dropdown>
                <Dropdown padding="medium" direction="bottom">Bottom</Dropdown>
                <Dropdown padding="medium" direction="left">Left</Dropdown>
              </StyleguidePreview>

              <EditableFields />

              <AttendeeListPreview />

              <StyleguidePreview
                description="Provides a QR code and login link to Android application"
                spacing="vertical"
                title="Access Control"
              >
                <AccessControl
                  accessToken="612bdd8a862a424d9001d8084d6ce463"
                  qrUrl="https://placehold.it/480x480"
                />
                <AccessControl
                  accessToken="612bdd8a862a424d9001d8084d6ce463"
                />
                <AccessControl />
              </StyleguidePreview>

              <StyleguidePreview
                description="Wraps some metadata information into a container"
                title="Metadata Wrapper"
              >
                <MetadataWrapper label="Venue">Irwin Ratke's bar (Jakubowski Squares)</MetadataWrapper>
                <MetadataWrapper label="Category">Live Comedy</MetadataWrapper>
                <MetadataWrapper
                  large
                  label="Tagline"
                  description="A short pithy description of your event which will be displayed alongside it when shown on YPlan"
                >
                  Slip and slide your way past London's skyline on this incredible ride.
                </MetadataWrapper>
                <MetadataWrapper label="Event Description">
                  <p styleName="paragraph">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer non placerat neque. Nam id lobortis nibh. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Curabitur feugiat quam sed nibh sodales, vel convallis mi egestas. Sed fringilla felis eget dolor condimentum iaculis. Donec vulputate, leo ut hendrerit dapibus, ipsum tellus sollicitudin felis, non vestibulum ipsum justo in neque. Nulla et molestie neque. Praesent nec interdum lacus.</p>
                </MetadataWrapper>
              </StyleguidePreview>

              <HeaderNavBarPreview />

              <StyleguidePreview
                spacing="vertical"
                title="Input"
              >
                <Input optional name="organisation" placeholder="Your organisation" value="" />
                <Input name="where" placeholder="Where is your event?" value="" />
                <Input error name="name" placeholder="Your Name" value="" />
              </StyleguidePreview>

              <StyleguidePreview
                spacing="vertical"
                title="Select"
              >
                <Select name="select" options={options} />
                <Select name="select" placeholder="Select your Market" options={options} />
                <Select error name="select" options={options} />
              </StyleguidePreview>

            </RelayoutItem>
          </Relayout>
        </RelayoutWrapper>
      </div>
    )
  }
}

export default CSSModules(Styleguide, styles)



/** WEBPACK FOOTER **
 ** ./src/containers/styleguide/styleguide.js
 **/